var _g, _rect, _g2, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleComfort({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 84,
    viewBox: "0 0 113 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6384_34733)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41 26L29 39L22 31",
    stroke: "#E827D9"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 31.5,
    stroke: "#E827D9"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6384_34733)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90 46L78 59L71 51",
    stroke: "#E827D9"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 20.5,
    width: 63,
    height: 63,
    rx: 31.5,
    stroke: "#E827D9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6384_34733"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6384_34733"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 20,
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleComfort);
export default __webpack_public_path__ + "static/media/double_comfort.2b3cbf09c5692304fc827a6099d6f3c4.svg";
export { ForwardRef as ReactComponent };